import { render, staticRenderFns } from "./CreateStaffGroupPopUp.vue?vue&type=template&id=7671acaf&scoped=true"
import script from "./CreateStaffGroupPopUp.vue?vue&type=script&lang=js"
export * from "./CreateStaffGroupPopUp.vue?vue&type=script&lang=js"
import style0 from "./CreateStaffGroupPopUp.vue?vue&type=style&index=0&id=7671acaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7671acaf",
  null
  
)

export default component.exports